export default "__VITE_ASSET__BVtiRekR__"